import { Component } from '@angular/core';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'frontegg',
  template: ``,
})
export class FronteggComponent {
}
